import BorrowerDashBanner from './borrower-dash-banner';

export default BorrowerDashBanner;
